import type { ReactNode } from 'react'

/** Icônes en SVG filaire — jamais d'émoji. Tracés simples, hérités de la couleur du texte. */
const TRACES = {
  building: <><path d="M3 21h18M5 21V8l7-5 7 5v13" /><path d="M9.5 21v-5h5v5M9.5 11h5" /></>,
  chart: <><path d="M3 3v18h18" /><path d="M7 14l4-4 3 3 5-6" /></>,
  card: <><rect x="2" y="5" width="20" height="14" rx="2.5" /><path d="M2 10h20M6 15h4" /></>,
  truck: <><path d="M3 16V7h9l4 3.5h4V16" /><circle cx="7.5" cy="17" r="2" /><circle cx="16.5" cy="17" r="2" /></>,
  package: <><path d="M21 8.5v7a2 2 0 01-1 1.73l-6 3.5a2 2 0 01-2 0l-6-3.5a2 2 0 01-1-1.73v-7a2 2 0 011-1.73l6-3.5a2 2 0 012 0l6 3.5a2 2 0 011 1.73z" /><path d="M3.3 7.3L12 12.3l8.7-5M12 22V12.3" /></>,
  hourglass: <><path d="M6 2h12M6 22h12" /><path d="M7 2c0 5 5 6 5 10s-5 5-5 10M17 2c0 5-5 6-5 10s5 5 5 10" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  download: <path d="M12 3v12M7 10l5 5 5-5M4 21h16" />,
  x: <path d="M18 6L6 18M6 6l12 12" />,
  check: <path d="M20 6L9 17l-5-5" />,
  logout: <><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" /><path d="M16 17l5-5-5-5M21 12H9" /></>,
  edit: <><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4z" /></>,
  alert: <><path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z" /><path d="M12 9v4M12 17h.01" /></>,
  lock: <><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 018 0v4" /></>,
  history: <><path d="M3 12a9 9 0 109-9 9 9 0 00-6.4 2.7L3 8" /><path d="M3 3v5h5M12 7v5l3 2" /></>,
  copy: <><rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" /></>,
  refresh: <><path d="M21 12a9 9 0 01-15.5 6.2L3 16" /><path d="M3 21v-5h5M3 12A9 9 0 0118.5 5.8L21 8" /><path d="M21 3v5h-5" /></>,
} satisfies Record<string, ReactNode>

export type NomIcone = keyof typeof TRACES

export function Icone({ nom, taille = 18 }: { nom: NomIcone; taille?: number }) {
  return (
    <svg
      className="ic"
      viewBox="0 0 24 24"
      width={taille}
      height={taille}
      aria-hidden="true"
      focusable="false"
    >
      {TRACES[nom]}
    </svg>
  )
}

/** Logo SwiftDeliver « colis + chevrons de vitesse ». `sombre` = version sur fond ink. */
export function Logo({ taille = 26, sombre = true }: { taille?: number; sombre?: boolean }) {
  const clair = sombre ? '#7FCBB4' : '#0F8A6A'
  const pli = sombre ? '#0B6B52' : '#EAF6F1'
  return (
    <svg viewBox="0 0 40 40" width={taille} height={taille} fill="none" aria-hidden="true" focusable="false">
      <rect x="14.5" y="10.5" width="20" height="20" rx="4.5" fill={clair} />
      <path d="M22 10.5v7.2l2.5-1.7 2.5 1.7v-7.2z" fill={pli} />
      <path d="M4.5 15.5h6.5M2.5 20.5h8.5M4.5 25.5h6.5" stroke={clair} strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  )
}

